var $1a81945131ad1f53$exports = {};
$1a81945131ad1f53$exports = {
    "actions": `Akcie`,
    "actionsAvailable": `Dostupn\xe9 akcie.`,
    "clearSelection": `Vymaza\u{165} v\xfdber`,
    "selected": (args)=>`Vybran\xe9 polo\u{17E}ky: ${args.count}`,
    "selectedAll": `V\u{161}etky vybrat\xe9 polo\u{17E}ky`
};


export {$1a81945131ad1f53$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
